import { gql } from 'graphql-request'

export const CREATE_BOOK_REPORT = gql`
  mutation CreateBookReport($createBookReportInput: CreateBookReportInput!) {
    createBookReport(createBookReportInput: $createBookReportInput) {
      message
    }
  }
`
